export default function IconCheckmark({ className }) {
    return (
        <svg
            className={className}
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
        >
            <path
                d="M13.5303 3.46966C13.2558 3.1951 12.821 3.17771 12.5264 3.41791L12.4698 3.46966L5.50006 10.4394L3.53034 8.46966L3.4737 8.41791C3.17916 8.17763 2.7444 8.19517 2.46979 8.46966C2.19519 8.74426 2.17773 9.17899 2.41803 9.47357L2.46979 9.53021L4.96979 12.0302C5.26268 12.3231 5.73744 12.3231 6.03034 12.0302L13.5303 4.53021L13.5821 4.47357C13.8223 4.17899 13.8049 3.74423 13.5303 3.46966Z"
                fill="currentColor"
            />
        </svg>
    );
}
